import React from "react";
import "./Footer.css";
import { IoIosArrowDropupCircle } from 'react-icons/io'

function Footer() {
  return (
    <div className="footer">
      <div className="footer__wrapper">
         <p>Designed and Built by <a href="https://github.com/GamsengMazee">Gamseng M Marak</a></p>
      </div>
      <div className="goTop__wrapper">
      <a title="Go Top" href="#home"><IoIosArrowDropupCircle size={20} className="icon"/></a>
    </div>
    </div>
  );
}

export default Footer;
